import styled from "styled-components";
import theme from "../theme";

const CheckboxList = styled.div`
  margin-bottom: ${theme.unit}px;
  max-height: ${theme.unit * 20}px;
  overflow: auto;
  label {
    margin-bottom: ${theme.unit}px;
  }
`;

export default CheckboxList;
